import { render, staticRenderFns } from "./putLinkDz.vue?vue&type=template&id=3b82dd56&scoped=true"
import script from "./putLinkDz.vue?vue&type=script&lang=js"
export * from "./putLinkDz.vue?vue&type=script&lang=js"
import style0 from "./putLinkDz.vue?vue&type=style&index=0&id=3b82dd56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b82dd56",
  null
  
)

export default component.exports